import { useState } from "react";
import {
  getBirthdayInFormat,
  getDate,
  getMonths,
  getYears,
  validateAge,
} from "../../helpers";
import { ButtonSubmit } from "../ButtonSubmit";
import { VideoMobile } from "../VideoMobile";
import "./Birthday.scss";

export const Birthday = ({ data, setData, nextStep }) => {
  const [errorBirthday, setErrorBirthday] = useState(null);
  const [birthdayData, setBirthdayData] = useState({});
  const [value, setValue] = useState("default");

  const handlerSubmit = (e) => {
    e.preventDefault();

    const {
      status,
      error,
      errors = {},
    } = validateAge(birthdayData.month, birthdayData.day, birthdayData.year);

    if (!status) {
      setErrorBirthday(error);
      return;
    }

    if (errors.invalidDate) {
      setErrorBirthday(error);
      return;
    }

    setData({
      ...data,
      birthday: getBirthdayInFormat(
        birthdayData.year,
        birthdayData.month,
        birthdayData.day,
      ),
    });

    nextStep();
  };

  const handleAddMonth = (e) => {
    setErrorBirthday(null);
    setBirthdayData({ ...birthdayData, month: e.target.value });
  };

  const handleAddDay = (e) => {
    setErrorBirthday(null);
    setBirthdayData({ ...birthdayData, day: e.target.value });
  };

  const handleAddYear = (e) => {
    setErrorBirthday(null);
    setBirthdayData({ ...birthdayData, year: e.target.value });
  };

  return (
    <div className="global__wrapper">
      <VideoMobile />
      <form className="form__global" onSubmit={handlerSubmit}>
        <h3 className="title__global">What's your date of birth?</h3>
        <div className="date__wrapper">
          <div className="date__wrapper-select">
            <select
              onChange={(e) => handleAddMonth(e)}
              defaultValue={value}
              className={
                (birthdayData.month ? "active" : "") +
                (errorBirthday ? "error" : "")
              }
            >
              <option value="default" disabled hidden>
                Month
              </option>
              {getMonths().map((item, index) => (
                <option key={index} value={index}>
                  {item || ""}
                </option>
              ))}
            </select>
          </div>
          <div className="date__wrapper-select">
            <select
              className={
                (birthdayData.day ? "active" : "") +
                (errorBirthday ? "error" : "")
              }
              onChange={(e) => handleAddDay(e)}
              defaultValue={value}
            >
              <option value="default" disabled hidden>
                Day
              </option>
              {getDate().map((item, index) => (
                <option key={index} value={index}>
                  {item || ""}
                </option>
              ))}
            </select>
          </div>
          <div className="date__wrapper-select">
            <select
              className={
                (birthdayData.year ? "active" : "") +
                (errorBirthday ? "error" : "")
              }
              onChange={(e) => handleAddYear(e)}
              defaultValue={value}
            >
              <option value="default" disabled hidden>
                Year
              </option>
              {getYears().map((item, index) => (
                <option key={index} value={item}>
                  {item || ""}
                </option>
              ))}
            </select>
          </div>
        </div>

        {errorBirthday && <p className="error-text">{errorBirthday}</p>}
        <ButtonSubmit className={"button"} text={"Continue"} />
      </form>
    </div>
  );
};
